import { parse } from 'date-fns';

import { removeSpaces } from './string';

export type TransformCreditCardFormValuesType = {
  firstName: string;
  lastName: string;
  expDate: string;
  cvc: string;
  number: string;
};

export function transformCreditCardFormValues<
  T extends TransformCreditCardFormValuesType,
>({ number, expDate, ...restValues }: T) {
  const parsedExp = parse(expDate, 'MM/yy', new Date());

  return {
    number: removeSpaces(number),
    expMonth: parsedExp.getMonth() + 1,
    expYear: parsedExp.getFullYear(),
    ...restValues,
  };
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function formatCurrencyToGBP(value: string) {
  return `\u00A3\u00A0${value}`;
}
